import { asyncPreactWidget } from '../../utils/async-preact-widget';
import { asyncModule } from '../../utils/async-module';
import * as JSModules from '../../components/modules';
import * as preactWidgets from '../../preact/widgets';
import { hasLmpTab } from '../../utils/aem-utils';

export const asyncVideoPlaylistInline = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.videoPlaylistInline);
  if (isOnPage() || hasLmpTab()) {
    start();
    import(`../../preact/widgets/video-playlist-inline`).then(hydrate).catch(error);
  }
};

export const asyncVideoArticle = () => {
  const $videoArticlePage = document.querySelector('.j-video-article-page');
  if ($videoArticlePage) {
    const { start, getInit, error } = asyncModule(JSModules.videoArticlePageModule);
    start();
    import('../../components/video-article-page/video-article-page').then(getInit()).catch(error);
  }
};

export const asyncMultipleVideoPlaylist = () => {
  const $multipleVideoPlaylist = document.querySelector('#j-player-with-carousel');
  if ($multipleVideoPlaylist) {
    const { shouldInit, start, getInit, error } = asyncModule(JSModules.multipleVideoPlaylistModule);
    if (shouldInit()) {
      start();
      import('../../components/multiple-video-playlist/multiple-video-playlist').then(getInit()).catch(error);
    }
  }
};

export const asyncVideoPlayers = () => {
  const $videoPlayer = document.querySelector('.j-player');
  if ($videoPlayer) {
    const { shouldInit, start, getInit, error } = asyncModule(JSModules.videoPlayerModule);
    if (shouldInit()) {
      start();
      import('../../components/video-player/init-players').then(getInit()).catch(error);
    }
  }
};

export const asyncWebviewVideoPlayer = () => {
  const $videoPlayerWebview = document.querySelector('.j-player');
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.webviewVideoPlayerModule);
  if (shouldInit() && $videoPlayerWebview) {
    start();
    import('../../components/webview-video-player/webview-video-player').then(getInit()).catch(error);
  }
};
